import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Clopotelul din antet - contractele lui `App\Notifications\Bell`.
 *
 * NUMELE DE AICI SUNT CELE DIN RASPUNS, litera cu litera. Serverul nu mai
 * trimite numele de coloane (`_id`, `notification_name`, `open_url` + `url` +
 * `additional_url`), cum facea portalul, ci randul gata facut; cheile sunt
 * prinse de amandoua partile - `NotificationsApiTest::testTheRowCarriesTheNames
 * TheScreenReads` si `NotificationsBell.test.tsx`.
 */

export type BellSeverity = 'info' | 'success' | 'warning' | 'error'

export interface BellRow {
  /** Numarul randului, ca text; alarmele poarta `alarm-<amprenta>`. */
  id: string
  /** `notification` = un rand din `it_notifications`; `alarm` = o stare a tabloului. */
  kind: 'alarm' | 'notification'
  title: string
  text: string
  severity: BellSeverity
  /** Clasa de iconita, asa cum o scrie catalogul (`fas fa-ticket-alt`). */
  icon: string
  /** Adresa din PORTAL (`easeedesk/ticket/4212`), sau `null` cand randul nu duce nicaieri. */
  href: string | null
  /** Alarmele nu se inchid cu mana: se rezolva. */
  dismissible: boolean
  /** Felurile care se sterg singure cand omul apasa pe ele. */
  closeOnClick: boolean
  created: string
}

export interface BellPanel {
  count: number
  notifications: BellRow[]
}

/**
 * Insigna. In portal se cere la fiecare 60 de secunde
 * (`resources/js/tasks/counters/Notifications.js`), si tot atat si aici.
 *
 * `refetchIntervalInBackground` ramane stins dinadins: o fila uitata deschisa
 * peste noapte ar bate serverul de o mie de ori degeaba, iar cand omul se
 * intoarce la ea numarul se reciteste oricum.
 */
export const bellCountQuery = queryOptions({
  queryKey: ['notifications', 'count'],
  queryFn: () => apiGet<{ count: number }>('/notifications/count'),
  refetchInterval: 60_000,
  staleTime: 30_000,
})

/** Lista se citeste PROASPAT la fiecare deschidere: o alarma veche de un minut nu mai e adevarata. */
export const bellPanelQuery = queryOptions({
  queryKey: ['notifications', 'panel'],
  queryFn: () => apiGet<BellPanel>('/notifications'),
  staleTime: 0,
  gcTime: 0,
})

/** Crucea de pe un rand. Serverul refuza randul altui om cu 404, nu tace. */
export function markRead(id: string): Promise<{ count: number }> {
  return apiPost<{ count: number }>(`/notifications/${encodeURIComponent(id)}/read`, {})
}

/** „Clear all". */
export function markAllRead(): Promise<{ cleared: number; count: number }> {
  return apiPost<{ cleared: number; count: number }>('/notifications/read-all', {})
}
